import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Bar } from 'react-chartjs-2'
import ChartDataLabels from 'chartjs-plugin-datalabels'

import GraphContainer from '../../GraphContainer'
import { hasChartData } from '../helpers/chartDataHelpers'

import { generateSdgMappingData } from './helpers'
import { getOptions } from './options'
import { useSroiReportCurrencySymbol } from '../../../hooks'
import { useSroiFilters } from '../../../SroiFiltersContext'

import { socialReturnOnInvestmentReportSelector } from '../../../../../../modules/selectors/socialReturnOnInvestment'

import { sdgIconPlugin } from './sdgIconPlugin'
import { fullWidthCharts, helpTexts } from '../../../constants'

import useStyles from './styles'

const MappingOfImpactToSdgs = () => {
  const { t } = useTranslation()
  const classes = useStyles()

  const report = useSelector(socialReturnOnInvestmentReportSelector)
  const currencySymbol = useSroiReportCurrencySymbol()
  const { selectedStakeholder } = useSroiFilters()

  const graphData = useMemo(() => {
    return generateSdgMappingData({ report, selectedStakeholder })
  }, [report, selectedStakeholder])

  const options = useMemo(() => {
    if (!graphData) return {}

    return getOptions(currencySymbol)
  }, [graphData, currencySymbol])

  const plugins = useMemo(() => {
    return [sdgIconPlugin, ChartDataLabels]
  }, [])

  // Don't render chart if there's no data
  if (!hasChartData(graphData)) {
    return null
  }

  return (
    <GraphContainer
      id={fullWidthCharts.sroiMappingSdgs}
      title={t('Mapping of Impact to SDGs')}
      helpText={helpTexts.mappingOfImpactToSdgs}
    >
      <div className={classes.chartWrapper}>
        <Bar type="bar" data={graphData} options={options} plugins={plugins} />
      </div>
    </GraphContainer>
  )
}

export default MappingOfImpactToSdgs
